import React, { useEffect, useState } from "react";
import {
  createArticle,
  getArticles,
  deleteArticle,
  updateArticle,
} from "../../../Api/Speakers/Articles";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";
import AddBlogModal from "./AddBlogModal";
import { useNavigate } from "react-router-dom";
import FormError from "../../../pages/Auth1/FormError";
import { ToastContainer, toast } from "react-toastify";

const BlogManagement = () => {
  const { t, i18n } = useTranslation();
  const languageDirection = i18n.language === "ar" ? "rtl" : "ltr";
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [showAddModal, setShowAddModal] = useState(false);
  const [articles, setArticles] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [currentArticle, setCurrentArticle] = useState(null);

  const loadBooks = async () => {
    try {
      const response = await getArticles({ page: 1, pageSize: 10 });
      setArticles(response.data.items || []);
    } catch (error) {
      console.error("Error fetching books:", error);
    }
  };

  // State to hold the form data
  const [articleData, setArticleData] = useState({
    arabicTitle: "",
    englishTitle: "",
    ArticleType: "",
    Link: "",
    arabicDescription: "",
    englishDescription: "",
    thumbnailImagePath: "",
    Tags: [],
    PublishToPublic: true,
    isExternalContent: false,
  });

  // شرط لتعديل isExternalContent بناءً على قيمة ArticleType
  useEffect(() => {
    if (articleData.ArticleType === 1) {
      setArticleData((prevData) => ({
        ...prevData,
        isExternalContent: false,
      }));
    } else {
      setArticleData((prevData) => ({
        ...prevData,
        isExternalContent: true,
      }));
    }
  }, [articleData.ArticleType]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "Link" && articleData.isExternalContent) {
      setArticleData({
        ...articleData,
        [name]: value,
      });
    } else {
      setArticleData({
        ...articleData,
        [name]: value,
      });
    }
  };

  // إضافة معالج تحميل الصور
  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      try {
      } catch (error) {
        console.error("Error handling image:", error);
        toast.error(t("AddArticle.errorUploadingImage"));
      }
    }
  };

  const handleSubmit = async (formDataFromModal) => {
    try {
      const response = await createArticle(formDataFromModal);
      if (response?.data) {
        toast.success(t("AddArticle.articleCreatedSuccessfully"));
        return true;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };

  const handleDelete = async (articleId) => {
    if (window.confirm(t("myArticles.confirm_delete"))) {
      try {
        await deleteArticle(articleId);
        toast.success(t("myArticles.article_deleted_successfully"));
      } catch (error) {
        console.error("Delete Error:", error);
        toast.error(t("myArticles.error_deleting_article"));
      }
    }
  };

  const handleEdit = (article) => {
    setCurrentArticle(article);
    setEditMode(true);
    setShowAddModal(true);
  };

  const maxLength = 500;
  // دالة لحساب النسبة المئوية للمحتوى المدخل
  const getColorForTextArea = (textLength) => {
    const percentage = (textLength / maxLength) * 100;
    if (percentage < 50) return "green"; // أقل من 50% الأخضر
    if (percentage < 90) return "orange"; // أقل من 90% البرتقالي
    return "red"; // 90% أو أكثر الأحمر
  };

  useEffect(() => {
    AOS.init({ duration: 1000 });
    loadBooks();
  }, []);

  return (
    <div dir={languageDirection}>
      <div
        className="tab-pane fade show active"
        id="blog"
        role="tabpanel"
        aria-labelledby="blog-tab"
      >
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3>{t("blog_management")}</h3>
          <button
            className="btn btn-primary"
            onClick={() => setShowAddModal(true)}
          >
            <i className="fas fa-plus me-2"></i> {t("add_new_Blog")}
          </button>
        </div>

        <div className="table-responsive">
          <table className="table table-hover">
            <thead className="table-light">
              <tr>
                <th width="70">#</th>
                <th>{t("post_title_ar")}</th>
                <th>{t("post_title_en")}</th>
                <th width="100">{t("status")}</th>
                {/* <th width="100">{t("date")}</th> */}
                <th width="150">{t("actions")}</th>
              </tr>
            </thead>
            <tbody>
              {articles.length === 0 ? (
                <tr className="no-data-message">
                  <td colSpan="6" className="text-center py-4">
                    <div className="empty-state">
                      <i className="fas fa-newspaper fa-3x mb-3 text-muted"></i>
                      <h5 className="text-muted">{t("noPostsMessage")}</h5>
                      <p className="text-muted small">
                        {t("press_add_to_add_article")}
                      </p>
                    </div>
                  </td>
                </tr>
              ) : (
                articles.map((article, index) => (
                  <tr key={article.id || index}>
                    <td>{index + 1}</td>
                    <td>{article.arabicTitle}</td>
                    <td>{article.englishTitle}</td>
                    <td>
                      {article.publishToPublic ? (
                        <span className="badge bg-success">
                          {t("published")}
                        </span>
                      ) : (
                        <span className="badge bg-secondary">{t("draft")}</span>
                      )}
                    </td>
                    {/* <td>{new Date(article.createdAt).toLocaleDateString()}</td> */}
                    <td>
                      {/* مثال على الإجراءات: */}
                      <button
                        className="btn btn-sm btn-outline-primary me-2"
                        onClick={() => handleEdit(article)}
                      >
                        <i className="fas fa-edit"></i>
                      </button>

                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => handleDelete(article.id)}
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* المودال الخاص بالإضافة */}
        <AddBlogModal
          show={showAddModal}
          onClose={() => {
            setShowAddModal(false);
            setEditMode(false);
            setCurrentArticle(null);
          }}
          onSuccess={loadBooks}
          handleSubmit={handleSubmit}
          editMode={editMode}
          initialData={currentArticle}
        />
      </div>
      <ToastContainer />
    </div>
  );
};

export default BlogManagement;
